import React, { Fragment } from 'react';
import UnifiedFAQ from '../../components/site/UnifiedFAQ/UnifiedFAQ';

export const FAQV6_ITEMS = [
  {
    question: 'O que é o Mercos?',
    paragraphs: [
      'O Mercos é um sistema de vendas para indústrias, distribuidoras e representantes comerciais que centraliza toda a operação de vendas em uma única plataforma. Reúne Inteligência Artificial, CRM, força de vendas, automação de pedidos, e-commerce B2B para vendas online, solução de pagamentos, dashboards inteligentes e integração com ERP em um só lugar.',
      'Com o Mercos, sua empresa automatiza desde o cadastro de clientes e produtos até a emissão de pedidos, o acompanhamento de indicadores, a gestão da equipe de vendas e as vendas online. Assim, reduz processos manuais, ganha produtividade e toma decisões com base em dados atualizados em tempo real.',
    ],
  },
  {
    question: 'Por que usar o Mercos na minha indústria ou distribuidora?',
    paragraphs: [
      'O Mercos ajuda empresas a organizar, automatizar e ampliar toda a operação comercial em um só lugar. É possível reduzir erros na emissão de pedidos, automatizar processos, centralizar informações de clientes, produtos e vendedores, acompanhar indicadores em tempo real, integrar o ERP da empresa e oferecer uma experiência de compra online por meio do e-commerce B2B.',
      'Além disso, a Mercos IA, a Inteligência Artificial do Mercos, reduz em até 90% o tempo gasto em tarefas que antes eram manuais, como criação de pedidos, geração de relatórios e análise de dados, permitindo que gestores e equipes comerciais foquem em vender mais e tomar decisões estratégicas.',
    ],
  },
  {
    question: 'Como o Mercos ajuda na gestão de pedidos e clientes?',
    paragraphs: [
      'O Mercos centraliza pedidos, clientes, produtos, tabelas de preços, condições comerciais, histórico de negociações e informações da equipe em um único sistema de vendas.',
      'Com isso, vendedores emitem pedidos pelo aplicativo ou pelo sistema online, de forma prática e respeitando as tabelas e políticas comerciais, enquanto gestores acompanham a operação em tempo real. Ambos obtêm informações de clientes com poucos cliques.',
      'Os seus clientes, por sua vez, podem realizar compras pelo e-commerce B2B, com regras comerciais integradas ao restante da operação. A plataforma também se integra ao ERP para manter os dados sincronizados entre as áreas comercial, financeira e administrativa.',
    ],
  },
  {
    question: 'O Mercos tem Inteligência Artificial para vendas?',
    paragraphs: [
      'Sim. A Mercos IA é uma Inteligência Artificial desenvolvida para apoiar gestores e equipes comerciais durante toda a operação de vendas.',
      'Com ela, é possível emitir pedidos a partir de conversas no WhatsApp, imagens, PDFs, áudios e documentos, consultar informações sobre clientes, pedidos e indicadores, gerar dashboards e relatórios personalizados, além de receber resumos inteligentes para agilizar atendimentos e tomadas de decisão.',
    ],
  },
  {
    question: 'Como funciona o sistema de vendas Mercos?',
    paragraphs: [
      'O Mercos funciona na web, no WhatsApp e também em aplicativos para celulares e tablets (Android e iOS), permitindo que equipes comerciais trabalhem no escritório ou em campo.',
      'Em uma única plataforma, gestores e vendedores acessam clientes, produtos, pedidos, CRM, indicadores, relatórios, agendas, políticas comerciais e histórico de vendas. O sistema automatiza processos, utiliza Inteligência Artificial para agilizar tarefas, integra-se ao ERP e permite vender tanto por equipes comerciais quanto por meio de um e-commerce B2B totalmente integrado à operação.',
    ],
  },
  {
    question: 'Quem pode usar o Mercos?',
    paragraphs: [
      'O Mercos foi desenvolvido para indústrias, distribuidoras, importadoras e representantes comerciais que desejam profissionalizar a gestão comercial, automatizar processos e aumentar a produtividade das equipes de vendas.',
      'A plataforma atende empresas de diferentes portes e níveis de maturidade, desde operações em crescimento até estruturas comerciais mais complexas, oferecendo recursos para vendas externas, vendas internas, gestão de equipes, relacionamento com clientes e e-commerce B2B para ampliar as vendas digitais.',
    ],
  },
  {
    question: 'Como começar a usar o Mercos?',
    paragraphs: [
      'Você pode testar o Mercos gratuitamente por 7 dias, sem informar cartão de crédito, ou solicitar uma demonstração com um especialista.',
      'Durante esse período, sua empresa conhece todos os recursos da plataforma e recebe orientação para identificar o plano mais adequado ao seu tamanho, estrutura comercial e objetivos de crescimento ao final do período gratuito.',
    ],
  },
  {
    question: 'O que faço se eu precisar de suporte adicional na utilização do Mercos?',
    paragraphs: [
      'A Mercos é reconhecida por seu suporte e atendimento próximos e de alto padrão, com um tempo de resposta de até 20 segundos em horário comercial, no WhatsApp ou chat, que fica dentro do sistema. Além disso, você pode acessar a Central de Ajuda, onde encontrará materiais e artigos que facilitam o uso do sistema.',
      'Também é possível entrar em contato com o time de suporte pelo e-mail contato@mercos.com ou pelo telefone (47) 3481 8050, de segunda a quinta, das 9h às 17h, e sexta-feira, das 9h30 às 17h.',
    ],
  },
];

export const FAQV6_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "O que é o Mercos?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O Mercos é um sistema de vendas para indústrias, distribuidoras e representantes comerciais que centraliza toda a operação de vendas em uma única plataforma. Reunimos Inteligência Artificial, CRM, força de vendas, automação de pedidos, e-commerce B2B para vendas online, solução de pagamentos, dashboards inteligentes e integração com ERP em um só lugar. Com o Mercos, sua empresa automatiza desde o cadastro de clientes e produtos até a emissão de pedidos, acompanhamento de indicadores, gestão da equipe de vendas e vendas online. Assim, reduz processos manuais, ganha produtividade e toma decisões com base em dados atualizados em tempo real."
      }
    },
    {
      "@type": "Question",
      "name": "Por que usar o Mercos na minha indústria ou distribuidora?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O Mercos ajuda empresas a organizar, automatizar e ampliar toda a operação comercial em um só lugar. É possível reduzir erros na emissão de pedidos, automatizar processos, centralizar informações de clientes, produtos e vendedores, acompanhar indicadores em tempo real, integrar o ERP da empresa e oferecer uma experiência de compra online por meio do e-commerce B2B. Além disso, a Mercos IA, a Inteligência Artificial do Mercos, diminui em até 90% o tempo gasto em tarefas que antes eram manuais, como criação de pedidos, geração de relatórios e análise de dados, permitindo que gestores e equipes comerciais foquem em vender mais e tomar decisões estratégicas."
      }
    },
    {
      "@type": "Question",
      "name": "Como o Mercos ajuda na gestão de pedidos e clientes?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O Mercos centraliza pedidos, clientes, produtos, tabelas de preço, condições comerciais, histórico de negociações e informações da equipe em um único sistema de vendas. Com isso, vendedores emitem pedidos pelo aplicativo ou pelo sistema online, de forma prática e respeitando as tabelas e políticas comerciais, enquanto gestores acompanham a operação em tempo real. Os clientes também podem realizar compras pelo e-commerce B2B com regras comerciais integradas ao restante da operação. A plataforma ainda se integra ao ERP para manter os dados sincronizados entre as áreas comercial, financeira e administrativa."
      }
    },
    {
      "@type": "Question",
      "name": "O Mercos tem Inteligência Artificial para vendas?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim. A Mercos IA é uma Inteligência Artificial desenvolvida para apoiar gestores e equipes comerciais durante toda a operação de vendas. Com ela, é possível emitir pedidos a partir de conversas no WhatsApp, imagens, PDFs, áudios e documentos, consultar informações sobre clientes, pedidos e indicadores, gerar dashboards e relatórios personalizados, além de receber resumos inteligentes para agilizar atendimentos e tomadas de decisão."
      }
    },
    {
      "@type": "Question",
      "name": "Como funciona o sistema de vendas Mercos?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O Mercos funciona na web, no WhatsApp e também em aplicativos para celulares e tablets Android e iOS, permitindo que equipes comerciais trabalhem no escritório ou em campo. Em uma única plataforma, gestores e vendedores acessam clientes, produtos, pedidos, CRM, indicadores, relatórios, agendas, políticas comerciais e histórico de vendas. O sistema automatiza processos, utiliza Inteligência Artificial para agilizar tarefas, integra-se ao ERP e permite vender tanto por equipes comerciais quanto por meio de um e-commerce B2B totalmente integrado à operação."
      }
    },
    {
      "@type": "Question",
      "name": "Quem pode usar o Mercos?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O Mercos foi desenvolvido para indústrias, distribuidoras, importadoras e representantes comerciais que desejam profissionalizar a gestão comercial, automatizar processos e aumentar a produtividade das equipes de vendas. A plataforma atende empresas de diferentes portes e níveis de maturidade, desde operações em crescimento até estruturas comerciais mais complexas, oferecendo recursos para vendas externas, vendas internas, gestão de equipes, relacionamento com clientes e e-commerce B2B para ampliar as vendas digitais."
      }
    },
    {
      "@type": "Question",
      "name": "Como começar a usar o Mercos?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Você pode testar o Mercos gratuitamente por 7 dias, sem informar cartão de crédito, ou solicitar uma demonstração com um especialista. Durante esse período, sua empresa conhece todos os recursos da plataforma e recebe orientação para identificar o plano mais adequado ao seu tamanho, estrutura comercial e objetivos de crescimento ao final do período gratuito."
      }
    },
    {
      "@type": "Question",
      "name": "O que faço se eu precisar de suporte adicional na utilização do Mercos?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A Mercos é reconhecida por seu suporte e atendimento próximos e de alto padrão, com tempo de resposta de até 20 segundos em horário comercial, pelo WhatsApp ou chat dentro do sistema. Além disso, você pode acessar a Central de Ajuda, onde encontrará materiais e artigos que facilitam o uso do sistema. Também é possível entrar em contato com o time de suporte pelo e-mail contato@mercos.com ou pelo telefone (47) 3481 8050, de segunda a quinta, das 9h às 17h, e sexta-feira das 9h30 às 17h."
      }
    }
  ]
};

const FAQV6 = ({ useSemanticHeadings = false }) => {
  const faqItems = FAQV6_ITEMS.map(({ question, paragraphs }) => ({
    question,
    answer: (
      <Fragment>
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </Fragment>
    ),
  }));

  return (
    <UnifiedFAQ
      subtitle={<p>Não conhece o sistema de vendas da Mercos? Confira as principais dúvidas que podem surgir.</p>}
      faqItems={faqItems}
      titleTag={useSemanticHeadings ? 'h2' : 'p'}
      questionTag={useSemanticHeadings ? 'h3' : 'span'}
      titleId="mercos-faq-title"
    />
  );
};

export default FAQV6;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/FAQ/FAQV6Test.jsx